import * as React from 'react';
import PropTypes from 'prop-types';
import {
    withStyles,
    Typography,
    Button,

} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Translate } from 'react-localize-redux';

import { DialogButton } from '../../youwell-common/components';

const styles = theme => ({
    root: {
        padding: theme.spacing(2, 4),
        background: theme.colors.grey2,
        display: 'flex',
        alignItems: 'center',
    },
    mainTitle: {
        flex: '1 1 auto',
    },
    button: {
        marginLeft: theme.spacing(1),
    },
    deleteButton: {
        color: theme.colors.red1,
        borderColor: theme.colors.red1,
        '&:hover': {
            backgroundColor: theme.colors.red2,
        },
    },
});

class BottomActionBar extends React.Component {
    render() {
        const {
            classes, title, onSave, cancelLink, saveMessage, saveEnabled, actionLink,
            onDelete,
        } = this.props;

        return (
            <>
                <div className={classes.root}>
                    <div className={classes.mainTitle}>
                        {title && (
                            <Typography variant="h5">
                                {title}
                            </Typography>
                        )}
                    </div>
                    {saveMessage && (
                        <Typography variant="caption">
                            {saveMessage}
                        </Typography>
                    )}
                    {cancelLink && (
                        <Button
                            className={classes.button}
                            color="secondary"
                            component={Link}
                            to={cancelLink}
                        >
                            <Translate id="common.cancel" />
                        </Button>
                    )}
                    {onSave && (
                        <Button
                            className={classes.button}
                            color="primary"
                            variant="contained"
                            onClick={onSave}
                            disabled={!saveEnabled}
                        >
                            <Translate id="common.save" />
                        </Button>
                    )}
                    {actionLink && (
                        <Button
                            to={actionLink.to}
                            component={Link}
                            variant="outlined"
                            color="primary"
                        >
                            {actionLink.text}
                        </Button>
                    )}
                    {onDelete && (
                        <DialogButton
                            buttonText={<Translate id="common.delete" />}
                            dialogTitle={<Translate id="common.delete" />}
                            dialogCancelText={<Translate id="common.cancel" />}
                            dialogOkAction={onDelete}
                            buttonProps={{ variant: 'outlined', className: classes.deleteButton }}
                        />
                    )}
                </div>
            </>
        );
    }
}

BottomActionBar.propTypes = {
    classes: PropTypes.object.isRequired,
    onSave: PropTypes.func,
    title: PropTypes.string,
    cancelLink: PropTypes.string,
    saveMessage: PropTypes.string,
    saveEnabled: PropTypes.bool,
    actionLink: PropTypes.object,
    onDelete: PropTypes.func,
};

BottomActionBar.defaultProps = {
    onSave: null,
    title: null,
    cancelLink: null,
    saveMessage: null,
    saveEnabled: true,
    actionLink: null,
    onDelete: null,
};

export default withStyles(styles)(BottomActionBar);
